import { render, staticRenderFns } from "./carparksettings.vue?vue&type=template&id=886fa2ee&"
import script from "./carparksettings.vue?vue&type=script&lang=js&"
export * from "./carparksettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports